// extracted by mini-css-extract-plugin
module.exports = {"container":"SkeletonList_container__I2MJq","skeletonContainer":"SkeletonList_skeletonContainer__qFMYq"};